import date from "./date";
import emailAddress from "./email-address";
import fullName from "./full-name";
import phoneNumber from "./phone-number";
import zipCode from "./zip-code";
import radioButton from "./radio-button";
import validateAddress from "./address";
import validateOptionalEmail from "./optional-email";
import validateOptionalPhone from "./optional-phone";

export default {
  date,
  emailAddress,
  fullName,
  phoneNumber,
  zipCode,
  radioButton,
  validateAddress,
  validateOptionalEmail,
  validateOptionalPhone,
};
